import { FilesIcon, ClockCounterClockwiseIcon, NotePencilIcon } from "@phosphor-icons/react";

const items = [
  {
    icon: FilesIcon,
    title: "Scattered documents",
    body: "Templates, drafts, partner notes and old submissions live in different places.",
  },
  {
    icon: NotePencilIcon,
    title: "Incomplete matter descriptions",
    body: "Strong work is too often summarised in two flat lines that don’t carry weight.",
  },
  {
    icon: ClockCounterClockwiseIcon,
    title: "Last-minute partner input",
    body: "Reviews land days before the deadline and the strategic narrative suffers.",
  },
];

export default function Problem() {
  return (
    <section id="problem" data-testid="problem-section" className="py-24 md:py-32 bg-[#f7f4ec]">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="max-w-3xl">
          <p className="text-sm uppercase tracking-[0.18em] font-semibold text-stone-500">
            The problem
          </p>
          <h2 className="mt-4 font-heading text-3xl md:text-5xl tracking-tight font-medium text-stone-900">
            Legal directory submissions are still too manual.
          </h2>
          <p className="mt-6 text-lg leading-relaxed text-stone-700">
            Every year, law firms prepare submissions using scattered documents,
            old templates, incomplete matter descriptions and last-minute input
            from partners. The problem is rarely lack of merit. It is lack of
            method.
          </p>
        </div>

        <div className="mt-14 grid grid-cols-1 md:grid-cols-3 gap-6">
          {items.map((it, idx) => {
            const Icon = it.icon;
            return (
              <div
                key={idx}
                data-testid={`problem-card-${idx}`}
                className="group relative rounded-2xl border border-stone-200 bg-[#f3efe6]/60 p-7 transition-all duration-300 hover:-translate-y-0.5 hover:shadow-md hover:border-stone-300"
              >
                <div className="inline-flex h-11 w-11 items-center justify-center rounded-xl bg-stone-900 text-[#f7f4ec] mb-5">
                  <Icon size={22} weight="duotone" />
                </div>
                <h3 className="font-heading text-xl font-medium text-stone-900">
                  {it.title}
                </h3>
                <p className="mt-2 text-stone-600 leading-relaxed">{it.body}</p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
